import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import _ from "lodash";
import { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";

import { useTranslation } from "react-i18next";

import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { BasicHbFilter } from "../../../../models/filters/basicHbFilter";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { AddTypeEstatePurposeObjectModal } from "./AddTypeEstatePurposeObjectModal";
import {
  useLazyGetTypeEstatePurposeObjectListQuery
} from "../../../../redux/api/handBooksApi/typeEstatePurposeObjectApi";
import { useTypeEstatePurposeObject } from "./useTypeEtatePurposeObject";
import { FilterByNameHB } from "../../../../components/filterByNameHB/FilterByNameHB";

enum FormField {
  name,
}

export const TypeEstatePurposeObject = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [form] = useForm();
  const { t } = useTranslation();
  const [selectedTypeEstatePurposeObject, setSelectedTypeEstatePurposeObject] = useState<EntDirectoryInfoName>(new EntDirectoryInfoName());
  const [showModal, setShowModal] = useState<boolean>(false);
  const {
	onAddTypeEstatePurposeObject,
	onEditTypeEstatePurposeObject,
	onDeleteTypeEstatePurposeObject
  } = useTypeEstatePurposeObject(modal, () => {
	searchHandleClick()
  })
  const [height, setHeight] = useState<number>(0);

  const [getData] = useLazyGetTypeEstatePurposeObjectListQuery();
  const {
	fetching,
	data,
	access,
	filter,
	totalItems,
	setData,
	setFetching,
	setFilter,
	setCurrentPage
  } = useGetDataOnScroll<EntDirectoryInfoName, BasicHbFilter>({
	initialFilter: new BasicHbFilter(),
	query: getData
  });

  const openAddModal = (item: EntDirectoryInfoName) => {
	setSelectedTypeEstatePurposeObject(item);
	setShowModal(true);
  };

  const setEntityFromFields = (): BasicHbFilter => {
	let filt: BasicHbFilter = _.clone(filter);
	filt.name = form.getFieldValue(FormField.name) ?? null;
	filt.page = 1;
	return filt;
  };

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	]);
  };

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  };

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 5 }>
			  <Spin
				spinning={ fetching }
				style={ {
				  width: '100%',
				  height: '180px',
				  display: 'flex',
				  alignItems: 'center',
				  justifyContent: 'center',
				} }
			  />
			</th>
		  </tr>
		) : (
		  <></>
		) }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button
					  className="btn_edit"
					  onClick={ () => {
						openAddModal(item)
					  } }
					  type="primary"
					  shape="circle"
					  icon={ <EditOutlined/> }
					/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button
					  className="btn_edit"
					  danger
					  onClick={ () => {
						onDeleteTypeEstatePurposeObject(item)
					  } }
					  type="primary"
					  shape="circle"
					  icon={ <DeleteOutlined/> }
					/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('titles.estate_purpose_object') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntDirectoryInfoName())
		} }>
		  { t('handbooks.estate_purpose_object.add_estate_purpose_object') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterByNameHB onSearch={ searchHandleClick } onReset={ () => {
		  clearFields();
		  searchHandleClick();
		} } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
		width={ 800 }
	  />
	  <AddTypeEstatePurposeObjectModal
		typeEstatePurposeObject={ selectedTypeEstatePurposeObject }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedTypeEstatePurposeObject.id !== 0 ? onEditTypeEstatePurposeObject : onAddTypeEstatePurposeObject }
	  />
	  { contextHolder }
	</>
  );
};
